import type { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import type {
  Bcp47Locale,
  Locale,
} from '@backmarket/http-api/src/standards/Locale'

export const languagesDict: { [localePrefix: string]: string } = {
  fr: 'Français',
  en: 'English',
  de: 'Deutsch',
  es: 'Español',
  it: 'Italiano',
  fi: 'Suomi',
  el: 'Ελληνικά',
  ja: '日本語',
  nl: 'Nederlands',
  pt: 'Português',
  sv: 'Svenska',
  sk: 'Slovenčina',
}

export function countryDisplayNameLocale(
  locale: Locale,
  countryCode: MarketCountryCode,
) {
  const localePrefix = locale.split('_')[0]
  const language = languagesDict[localePrefix] || ''

  return `${language} (${countryCode})`
}

export function countryDisplayNameBcp47(
  locale: Bcp47Locale,
  countryCode: MarketCountryCode,
) {
  const localePrefix = locale.split('-')[0]
  const language = languagesDict[localePrefix] || ''

  return `${language} (${countryCode})`
}

export function languageName(locale: Locale) {
  const localePrefix = locale.split('_')[0]

  return languagesDict[localePrefix] || ''
}

export function languageNameBcp47(locale: Bcp47Locale) {
  const localePrefix = locale.split('-')[0]

  return languagesDict[localePrefix] || ''
}
